import React from 'react';
import PropTypes from 'prop-types';

import Img from '../../../../../components/Img';

import styles from './eventProfileMatchCard.scss';

const ScoreRowContent = ({
    keyPrefix,
    scores,
    liveScore,
    isServing,
    shouldDisplayLiveData,
    wrapperClassName,
}) => {
    if (!scores) {
        return null;
    }

    return (
        <div className={wrapperClassName}>
            {shouldDisplayLiveData && isServing && (
                <Img
                    src="/img/icons/v4/show-live-ball.svg"
                    className={styles.serverIndicator}
                    alt="Serving"
                />
            )}
            {shouldDisplayLiveData && liveScore != null && (
                <>
                    <span className={styles.liveScore}>{liveScore}</span>
                    <span className={styles.separator}> | </span>
                </>
            )}
            {scores.map((setScore, idx) => (
                <span
                    key={`${keyPrefix}-set-${idx}-${setScore.score}-${setScore.tiebreakValue ?? ''}`}
                    className={`${styles.setScore} ${setScore.isHigher ? styles.winnerScore : ''}`}
                >
                    {setScore.score}
                    {setScore.tiebreakValue != null && <sup>{setScore.tiebreakValue}</sup>}
                </span>
            ))}
        </div>
    );
};

ScoreRowContent.propTypes = {
    keyPrefix: PropTypes.string.isRequired,
    scores: PropTypes.arrayOf(PropTypes.shape({
        score: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        tiebreakValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        isHigher: PropTypes.bool,
    })),
    liveScore: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isServing: PropTypes.bool,
    shouldDisplayLiveData: PropTypes.bool,
    wrapperClassName: PropTypes.string.isRequired,
};

ScoreRowContent.defaultProps = {
    scores: null,
    liveScore: null,
    isServing: false,
    shouldDisplayLiveData: false,
};

export default ScoreRowContent;
